<main>
    <section class="well bg-color">
        <div class="container">
            <h3 class="center">{{"NAV.ERIKOISSOVELLUS" | translate}}</h3>
            <div class="row">
                <div class="grid_6"><img src="assets/images/Erikoissovellukset-miina.jpg" alt=""></div>
                <div class="grid_6 mg-add">
                    <h6>{{"ERIKOIS.TITLE" | translate}}</h6>
                    <p class="txt1">
                        {{"ERIKOIS.DESCRIPTION" | translate}}
                    </p>
                </div>
            </div>
        </div>
    </section>
    <section class="well center">
        <div class="container">
            <h3>{{"TOTEUTUKSIA" | translate}}</h3>
            <div class="row off1">
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                        src="assets/images/hitec-h510-kaapeliauraus-1-768x576.jpeg"
                                                        alt=""><span>{{"ERIKOIS.BOX1" | translate}}</span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                        src="assets/images/H500-Unimog-egy-7.jpg"
                                                        alt=""><span>{{"ERIKOIS.BOX2" | translate}}</span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                        src="assets/images/erikoissovellukset.jpg"
                                                        alt=""><span>{{"ERIKOIS.BOX3" | translate}}</span></a>
                </div>
            </div>
            <div class="row off1">
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                        src="assets/images/S4100014-768x576.jpg"
                                                        alt=""><span>{{"ERIKOIS.BOX4" | translate}}</span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                        src="assets/images/2010-28-January-H203-AL-042-1024x683.jpg"
                                                        alt=""><span>{{"ERIKOIS.BOX5" | translate}}</span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                        src="assets/images/H500N-yleiskuva_11_5_2006-094-768x582.jpg"
                                                        alt=""><span>{{"ERIKOIS.BOX6" | translate}}</span></a>
                </div>
            </div>
        </div>
    </section>
</main>
